import * as React from 'react'
import {NPErrorBoundary} from '@components/error-boundary'
import {PageLoadingIndicator} from '@components/page-loading-indicator'
import {QueryClientProvider} from '@tanstack/react-query'
import {reactQueryClient} from '@applications/utility-methods'
const NewViewServicesWithDataComponent = React.lazy(
  () => import(/* webpackChunkName: "services-page" */ './index'),
)

const NewviewServicesWithData = () => (
  <QueryClientProvider client={reactQueryClient}>
    <NPErrorBoundary>
      <React.Suspense fallback={<PageLoadingIndicator />}>
        <NewViewServicesWithDataComponent />
      </React.Suspense>
    </NPErrorBoundary>
  </QueryClientProvider>
)

export default NewviewServicesWithData
